/**
 * Header Modern - JavaScript functionality
 * Handles mobile menu toggle, dropdown interactions, and sticky header
 */
(function() {
    'use strict';
    
    // ─── Mobile Menu ──────────────────────────────────────────────────────────
    const mobileMenuToggle  = document.querySelector('[data-mobile-menu-toggle]');
    const mobileMenu        = document.querySelector('[data-mobile-menu]');
    const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
    const mobileMenuPanel      = document.querySelector('#mobile-menu-panel');
    const mobileMenuScrollArea = document.querySelector('.header__mobile-menu-main-content');
    const mobileMenuLocale     = document.querySelector('[data-mobile-menu-locale]');
    const mobileMenuLocaleSelect = mobileMenuLocale && mobileMenuLocale.querySelector('[data-currency-selector], .header__mobile-menu-locale-select');
    const header               = document.querySelector('.header--modern');

    const FOCUSABLE = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    let _trapFocusHandler = null;
    let _scrollLockY = 0;
    let _closeTimer = null;
    let _backgroundScrollHandler = null;

    const STICKY_THRESHOLD = 120;
    const MENU_TRANSITION_MS = 300;
    const hubPanel = document.querySelector('[data-hub-panel]');

    function syncMobileMenuLocaleFlag() {
        if (!mobileMenuLocale || !mobileMenuLocaleSelect || !mobileMenuLocaleSelect.value) return;
        mobileMenuLocale.dataset.currency = mobileMenuLocaleSelect.value.toUpperCase();
    }

    if (mobileMenuLocaleSelect) {
        mobileMenuLocaleSelect.addEventListener('change', syncMobileMenuLocaleFlag);
        window.addEventListener('load', syncMobileMenuLocaleFlag);
        document.addEventListener('booster:loaded', syncMobileMenuLocaleFlag);
    }

    function isMenuActive() {
        return mobileMenu && mobileMenu.classList.contains('header__mobile-menu--active');
    }

    function getFocusableEls() {
        if (!mobileMenuPanel) return [];
        return Array.from(mobileMenuPanel.querySelectorAll(FOCUSABLE)).filter(function(el) {
            return !el.closest('[hidden]') && el.offsetParent !== null;
        });
    }

    function trapFocus(e) {
        if (e.key !== 'Tab') return;
        var els   = getFocusableEls();
        var first = els[0];
        var last  = els[els.length - 1];
        if (!first) return;

        if (e.shiftKey) {
            if (document.activeElement === first) {
                e.preventDefault();
                last.focus();
            }
        } else if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    function getHeaderSection() {
        return header ? header.parentElement : null;
    }

    function setHeaderSectionHeight(height) {
        var section = getHeaderSection();
        if (!section) return;

        if (height) {
            section.style.height = height + 'px';
            section.style.minHeight = height + 'px';
        } else {
            section.style.height = '';
            section.style.minHeight = '';
        }
    }

    function preventBackgroundScroll(e) {
        if (mobileMenuScrollArea && mobileMenuScrollArea.contains(e.target)) {
            return;
        }
        e.preventDefault();
    }

    function lockBodyScroll() {
        _scrollLockY = window.scrollY;
        if (_backgroundScrollHandler) return;

        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        _backgroundScrollHandler = preventBackgroundScroll;
        document.addEventListener('wheel', _backgroundScrollHandler, { passive: false });
        document.addEventListener('touchmove', _backgroundScrollHandler, { passive: false });
    }

    function unlockBodyScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';

        if (_backgroundScrollHandler) {
            document.removeEventListener('wheel', _backgroundScrollHandler);
            document.removeEventListener('touchmove', _backgroundScrollHandler);
            _backgroundScrollHandler = null;
        }
    }

    function syncStickyHeader(scrollYOverride) {
        if (!header || header.getAttribute('data-sticky') !== 'true') return;
        if (isMenuActive() || (mobileMenu && mobileMenu.classList.contains('header__mobile-menu--closing'))) return;

        var scrollY = typeof scrollYOverride === 'number' ? scrollYOverride : window.scrollY;

        if (scrollY > STICKY_THRESHOLD) {
            setHeaderSectionHeight(header.clientHeight);
            header.classList.add('header--modern-sticky');
        } else {
            setHeaderSectionHeight(null);
            header.classList.remove('header--modern-sticky');
        }
    }

    function getMenuTopOffset() {
        var topOffset = 0;
        var announcementBar = document.querySelector('.top-bar');

        if (announcementBar && window.getComputedStyle(announcementBar).display !== 'none') {
            var announcementRect = announcementBar.getBoundingClientRect();
            if (announcementRect.bottom > 0) {
                topOffset = Math.max(topOffset, announcementRect.bottom);
            }
        }

        if (header) {
            var headerRect = header.getBoundingClientRect();
            if (headerRect.bottom > 0) {
                topOffset = Math.max(topOffset, headerRect.bottom);
            } else if (header.classList.contains('header--modern-sticky') || window.scrollY > 0 || _scrollLockY > 0) {
                topOffset = Math.max(topOffset, header.offsetHeight);
            }
        }

        return Math.max(0, topOffset);
    }

    function applyMenuPosition() {
        if (!mobileMenu) return;

        var topOffset = getMenuTopOffset();
        var heightUnit = CSS && CSS.supports && CSS.supports('height', '1dvh') ? '100dvh' : '100vh';

        mobileMenu.style.top = topOffset + 'px';
        mobileMenu.style.height = 'calc(' + heightUnit + ' - ' + topOffset + 'px)';
    }

    function clearMenuPosition() {
        if (!mobileMenu) return;
        mobileMenu.style.top = '';
        mobileMenu.style.height = '';
    }

    function completeMenuClose(savedScrollY) {
        if (_closeTimer) {
            clearTimeout(_closeTimer);
            _closeTimer = null;
        }

        if (mobileMenu) {
            mobileMenu.classList.remove('header__mobile-menu--active', 'header__mobile-menu--closing');
        }

        document.body.classList.remove('header-mobile-menu-open');
        if (header) {
            header.classList.remove('header--modern--menu-open');
        }
        var headerSection = getHeaderSection();
        if (headerSection) {
            headerSection.classList.remove('header-section--menu-open');
        }

        if (header && header.getAttribute('data-sticky') === 'true') {
            if (savedScrollY > STICKY_THRESHOLD) {
                setHeaderSectionHeight(header.clientHeight);
                header.classList.add('header--modern-sticky');
            } else {
                setHeaderSectionHeight(null);
                header.classList.remove('header--modern-sticky');
            }
        } else {
            setHeaderSectionHeight(null);
        }

        unlockBodyScroll();
        clearMenuPosition();
    }

    function openMobileMenu() {
        if (!mobileMenu || isMenuActive()) return;

        if (_closeTimer) {
            clearTimeout(_closeTimer);
            _closeTimer = null;
            mobileMenu.classList.remove('header__mobile-menu--closing');
        }

        _scrollLockY = window.scrollY;
        setHeaderSectionHeight(header && header.parentElement ? header.parentElement.offsetHeight : null);
        document.body.classList.add('header-mobile-menu-open');
        if (header) {
            header.classList.add('header--modern--menu-open');
        }
        var headerSection = getHeaderSection();
        if (headerSection) {
            headerSection.classList.add('header-section--menu-open');
        }

        lockBodyScroll();
        applyMenuPosition();

        if (mobileMenuScrollArea) {
            mobileMenuScrollArea.scrollTop = 0;
        }

        mobileMenu.classList.add('header__mobile-menu--active');

        if (mobileMenuToggle) {
            mobileMenuToggle.setAttribute('aria-expanded', 'true');
            mobileMenuToggle.setAttribute('aria-label', 'Close navigation menu');
        }

        setTimeout(function() {
            var firstEl = getFocusableEls()[0];
            if (firstEl) firstEl.focus();
        }, 50);

        if (_trapFocusHandler) {
            document.removeEventListener('keydown', _trapFocusHandler);
        }
        _trapFocusHandler = trapFocus;
        document.addEventListener('keydown', _trapFocusHandler);
    }

    function closeMobileMenu() {
        if (!mobileMenu || !isMenuActive()) return;

        var savedScrollY = _scrollLockY;
        var didComplete = false;

        function finishClose() {
            if (didComplete) return;
            didComplete = true;
            completeMenuClose(savedScrollY);

            if (mobileMenuToggle) {
                mobileMenuToggle.focus();
            }

            requestAnimationFrame(function() {
                syncStickyHeader(savedScrollY);
            });
        }

        mobileMenu.classList.remove('header__mobile-menu--active');
        mobileMenu.classList.add('header__mobile-menu--closing');

        if (mobileMenuToggle) {
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            mobileMenuToggle.setAttribute('aria-label', 'Open navigation menu');
        }

        if (_trapFocusHandler) {
            document.removeEventListener('keydown', _trapFocusHandler);
            _trapFocusHandler = null;
        }

        if (mobileMenuPanel) {
            var onTransitionEnd = function(e) {
                if (e.target !== mobileMenuPanel || e.propertyName !== 'transform') return;
                mobileMenuPanel.removeEventListener('transitionend', onTransitionEnd);
                finishClose();
            };
            mobileMenuPanel.addEventListener('transitionend', onTransitionEnd);
        }

        _closeTimer = setTimeout(finishClose, MENU_TRANSITION_MS + 50);
    }

    function toggleMobileMenu() {
        if (isMenuActive()) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    }

    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', toggleMobileMenu);
    }

    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape') return;
        if (isHubPanelOpen()) {
            closeHubPanel();
            return;
        }
        if (isMenuActive()) {
            closeMobileMenu();
        }
    });

    var _resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(_resizeTimer);
        _resizeTimer = setTimeout(function() {
            if (isMenuActive()) {
                applyMenuPosition();
            }
        }, 100);
    });

    if (header) {
        var headerObserver = new MutationObserver(function() {
            if (isMenuActive()) {
                applyMenuPosition();
            }
        });
        headerObserver.observe(header, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
    
    // Handle mega menu on desktop
    const menuItems = document.querySelectorAll('.header--modern__menu-item--has-dropdown');
    
    function updateMegamenuPosition() {
        if (!header) return;
        
        const headerRect = header.getBoundingClientRect();
        const headerBottom = headerRect.bottom;
        const topPosition = headerBottom;
        
        const megamenus = document.querySelectorAll('.header--modern__megamenu');
        megamenus.forEach(function(megamenu) {
            megamenu.style.top = topPosition + 'px';
        });
        
        const overlay = document.querySelector('.header--modern__megamenu-overlay');
        if (overlay) {
            overlay.style.top = topPosition + 'px';
        }

        // Hub panel shares megamenu attachment: below navbar, announcement stays clear
        if (hubPanel) {
            hubPanel.style.top = topPosition + 'px';
        }
    }
    
    updateMegamenuPosition();
    window.addEventListener('resize', updateMegamenuPosition);
    
    if (header) {
        const observer = new MutationObserver(function() {
            updateMegamenuPosition();
        });
        observer.observe(header, { attributes: true, attributeFilter: ['class'] });
        
        const announcementBar = document.querySelector('.top-bar');
        if (announcementBar) {
            observer.observe(announcementBar, { 
                attributes: true, 
                attributeFilter: ['class', 'style'],
                childList: true,
                subtree: true
            });
        }
    }
    
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        updateMegamenuPosition();
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateMegamenuPosition, 50);
    });
    
    const allDropdowns = document.querySelectorAll('.header--modern__megamenu, .header--modern__resources-dropdown');
    const megamenuOverlay = document.querySelector('.header--modern__megamenu-overlay');
    const CLOSE_DELAY = 80;
    let closeTimer = null;
    let activeItem = null;
    let activeDropdown = null;

    function getDropdownSurface(dropdown) {
        if (!dropdown) return null;
        if (dropdown.classList.contains('header--modern__megamenu')) {
            return dropdown.querySelector('.header--modern__megamenu-container') || dropdown;
        }
        return dropdown;
    }

    function isMenuNavTarget(el) {
        if (!el || !el.closest) return false;
        if (el.closest('.header--modern__menu-item--has-dropdown')) return true;
        if (el.closest('.header--modern__menu')) return true;
        return false;
    }

    function shouldKeepOpen(relatedTarget) {
        if (!relatedTarget) return false;
        if (activeItem && activeItem.contains(relatedTarget)) return true;

        var surface = getDropdownSurface(activeDropdown);
        if (surface && surface.contains(relatedTarget)) return true;

        return isMenuNavTarget(relatedTarget);
    }

    function setDropdownTransition(dropdown, enabled) {
        if (!dropdown) return;
        dropdown.style.transition = enabled ? '' : 'none';
    }

    function closeDropdown(dropdown, instant) {
        if (!dropdown) return;
        if (instant) setDropdownTransition(dropdown, false);
        dropdown.classList.remove('is-open');
        dropdown.style.visibility = 'hidden';
        dropdown.style.opacity = '0';
        dropdown.style.transform = 'translateY(10px)';
        if (instant) {
            void dropdown.offsetHeight;
            setDropdownTransition(dropdown, true);
        }
    }

    function closeAllDropdowns() {
        clearTimeout(closeTimer);
        allDropdowns.forEach(closeDropdown);
        if (megamenuOverlay) {
            megamenuOverlay.style.opacity = '0';
            megamenuOverlay.style.visibility = 'hidden';
        }
        document.body.classList.remove('megamenu-open');
        activeItem = null;
        activeDropdown = null;
    }

    function scheduleCloseAll() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAllDropdowns, CLOSE_DELAY);
    }

    function openDropdown(item, dropdown) {
        if (!dropdown || isHubPanelOpen()) return;
        clearTimeout(closeTimer);

        var isSwitching = activeDropdown && activeDropdown !== dropdown;

        allDropdowns.forEach(function(menu) {
            if (menu !== dropdown) closeDropdown(menu, isSwitching);
        });

        activeItem = item;
        activeDropdown = dropdown;

        if (!dropdown.classList.contains('header--modern__resources-dropdown')) {
            updateMegamenuPosition();
        }

        if (isSwitching) setDropdownTransition(dropdown, false);

        dropdown.classList.add('is-open');
        dropdown.style.visibility = 'visible';
        dropdown.style.opacity = '1';
        dropdown.style.transform = 'translateY(0)';

        if (isSwitching) {
            void dropdown.offsetHeight;
            setDropdownTransition(dropdown, true);
        }

        if (megamenuOverlay) {
            megamenuOverlay.style.opacity = '1';
            megamenuOverlay.style.visibility = 'visible';
            document.body.classList.add('megamenu-open');
        }
    }

    menuItems.forEach(function(item) {
        var dropdown = item.querySelector('.header--modern__megamenu') ||
                       item.querySelector('.header--modern__resources-dropdown');
        if (!dropdown) return;

        var surface = getDropdownSurface(dropdown);

        item.addEventListener('mouseenter', function() {
            openDropdown(item, dropdown);
        });

        item.addEventListener('mouseleave', function(e) {
            if (shouldKeepOpen(e.relatedTarget)) return;
            scheduleCloseAll();
        });

        if (surface && surface !== dropdown) {
            surface.addEventListener('mouseenter', function() {
                openDropdown(item, dropdown);
            });

            surface.addEventListener('mouseleave', function(e) {
                if (shouldKeepOpen(e.relatedTarget)) return;
                scheduleCloseAll();
            });
        } else {
            dropdown.addEventListener('mouseenter', function() {
                openDropdown(item, dropdown);
            });

            dropdown.addEventListener('mouseleave', function(e) {
                if (shouldKeepOpen(e.relatedTarget)) return;
                scheduleCloseAll();
            });
        }
    });

    var menuNav = document.querySelector('.header--modern__menu');
    if (menuNav) {
        menuNav.addEventListener('mouseenter', function() {
            clearTimeout(closeTimer);
        });
    }

    function isHubPanelOpen() {
        return hubPanel && hubPanel.classList.contains('is-open');
    }

    function setHubToggleState(isOpen) {
        document.querySelectorAll('[data-hub-toggle]').forEach(function(btn) {
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
        if (hubPanel) {
            hubPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
    }

    function closeHubPanel() {
        if (!hubPanel || !isHubPanelOpen()) return;
        hubPanel.classList.remove('is-open');
        setHubToggleState(false);
    }

    function openHubPanel() {
        if (!hubPanel) return;
        closeAllDropdowns();
        updateMegamenuPosition();
        hubPanel.classList.add('is-open');
        setHubToggleState(true);
    }

    function toggleHubPanel() {
        if (isHubPanelOpen()) closeHubPanel();
        else openHubPanel();
    }

    document.querySelectorAll('[data-hub-toggle]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            toggleHubPanel();
        });
    });

    document.querySelectorAll('[data-hub-close]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            closeHubPanel();
        });
    });

    if (header && header.getAttribute('data-sticky') === 'true') {
        function debounce(func, timeout = 300) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, args); }, timeout);
            };
        }
        
        const checkSticky = () => {
            syncStickyHeader();
            updateMegamenuPosition();
        };
        
        window.addEventListener('scroll', debounce(checkSticky, 75));
        window.addEventListener('resize', debounce(checkSticky, 150));
    }

    window.openHeaderSearch = function () {
        closeHubPanel();
        var container = document.querySelector('[data-search-container]');
        var input = container && container.querySelector('input[data-search]');
        if (window.BoosterTheme && window.BoosterTheme.ELEMENTS) {
            window.BoosterTheme.ELEMENTS.openSearch(input);
        } else if (container) {
            container.classList.add('focused');
        }
        if (input) input.focus();
    };
})();
